import { AxiosError } from 'axios';

export const isAxiosError = (exception: any): exception is AxiosError => {
  return 'config' in exception && 'request' in exception && 'url' in exception.config && 'method' in exception.config;
};
